<template>
  <div>
    <LoadingComponent :loading="loading" :message="$t('system.messages.loading')" show-elapsed style="z-index: 1000;"></LoadingComponent>
    <v-dialog v-model="validacaoDialog" scrollable max-width="1100" style="border-radius: 10px;">
      <v-card>
        <v-card-title style="color: #4a4a4a">
          {{ $t('externalAddress.validationResult.title') }}
          <v-spacer></v-spacer>
          <v-chip small label :color="validacaoTemErro ? 'red darken-2' : 'green darken-2'" dark>
            {{ validacaoTemErro
              ? $t('externalAddress.validationResult.withErrors')
              : $t('externalAddress.validationResult.allOk') }}
          </v-chip>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 70vh;">
          <div
            v-for="(res, idx) in validacaoResultados"
            :key="'res-' + res.idExternal + '-' + idx"
            class="mt-4">
            <div class="d-flex align-center flex-wrap">
              <strong style="color: #4a4a4a">
                {{ $t('externalAddress.headers.externalId') }} {{ res.idExternal }}
              </strong>
              <span v-if="res.enderecoResumo" class="text-caption grey--text text--darken-1 ml-2">
                {{ res.enderecoResumo }}
              </span>
              <v-spacer></v-spacer>
              <v-chip x-small label class="ml-2" :color="res.erro || res.rejeitado ? 'red darken-2' : 'green darken-2'" dark>
                {{ res.erro
                  ? $t('externalAddress.validationResult.failed')
                  : res.rejeitado
                    ? $t('externalAddress.validationResult.rejected')
                    : $t('externalAddress.validationResult.succeeded') }}
              </v-chip>
              <v-chip v-if="res.upsertLabel" x-small label outlined class="ml-2">{{ res.upsertLabel }}</v-chip>
              <v-chip v-if="res.tempoValidacao" x-small label outlined class="ml-2">
                <v-icon x-small left>mdi-timer-outline</v-icon>{{ res.tempoValidacao }}
              </v-chip>
              <v-chip v-if="res.caminhadaCalculada != null" x-small label outlined class="ml-2">
                <v-icon x-small left>{{ res.caminhadaCalculada ? 'mdi-walk' : 'mdi-vector-line' }}</v-icon>
                {{ res.caminhadaCalculada
                  ? $t('externalAddress.validationResult.walkCalculated')
                  : $t('externalAddress.validationResult.walkNotCalculated') }}
              </v-chip>
            </div>

            <p class="mb-2 mt-1" :class="res.erro ? 'red--text text--darken-2' : ''">
              {{ res.mensagem }}
            </p>

            <v-simple-table v-if="res.cercas.length" dense class="elevation-1" style="border-radius: 8px;">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>{{ $t('candidate.jobOffer.shift') }}</th>
                    <th>{{ $t('candidate.headers.main.bestLine') }}</th>
                    <th>{{ $t('candidate.headers.main.bestStop') }}</th>
                    <th class="text-right">{{ $t('externalAddress.validationResult.walkDistance') }}</th>
                    <th class="text-right">{{ $t('candidate.rideTime.label') }}</th>
                    <th class="text-right">{{ $t('externalAddress.validationResult.availableSeats') }}</th>
                    <th>{{ $t('externalAddress.validationResult.status') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cerca, i) in res.cercas" :key="'cerca-' + idx + '-' + i">
                    <td>{{ cerca.turno }}</td>
                    <td>{{ cerca.linha }}</td>
                    <td>{{ cerca.cerca }}</td>
                    <td class="text-right">
                      {{ cerca.distancia }}
                      <v-tooltip top v-if="!cerca.distanciaReal">
                        <template v-slot:activator="{ on }">
                          <span v-on="on" class="grey--text">!</span>
                        </template>
                        <div>{{ $t('externalAddress.validationResult.straightLineFallback') }}</div>
                      </v-tooltip>
                    </td>
                    <td class="text-right">
                      <span :class="cerca.tempoLinhaExcede ? 'orange--text text--darken-3 font-weight-medium' : ''">
                        {{ cerca.tempoLinha }}
                      </span>
                      <v-tooltip top v-if="cerca.tempoLinhaExcede">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" x-small color="orange darken-3" class="ml-1">mdi-clock-alert-outline</v-icon>
                        </template>
                        <div>{{ cerca.tempoLinhaTooltip }}</div>
                      </v-tooltip>
                    </td>
                    <td class="text-right">{{ cerca.vagas }}</td>
                    <td>
                      <span class="validacao-status-dot" :style="{ backgroundColor: cerca.cor }"></span>
                      {{ cerca.status }}
                      <v-icon v-if="cerca.precisaAjusteTurno" x-small color="orange darken-2" class="ml-1">
                        mdi-alert
                      </v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <p v-else class="text-caption grey--text mb-0">
              {{ $t('externalAddress.validationResult.noFences') }}
            </p>

            <v-divider v-if="idx < validacaoResultados.length - 1" class="mt-4" />
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="white--text" @click="validacaoDialog = false">
            {{ $t('button.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="900" style="border-radius: 10px;">
      <v-card>
        <v-card-title style="color: #4a4a4a">{{ formTitle }}</v-card-title>
        <v-card-text>
          <v-form ref="formEndereco" v-model="formValido">
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="editedItem.id_endereco_externo"
                  :label="$t('externalAddress.headers.externalId')"
                  :hint="$t('externalAddress.form.externalIdOptionalHint')"
                  persistent-hint />
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <v-select
                  v-model="editedItem.id_agencia_emprego"
                  :items="agencias"
                  :item-text="agenciaLabel"
                  item-value="id_agencia_emprego"
                  :label="$t('candidate.headers.main.agency')"
                  clearable />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="editedItem.pais"
                  :items="paises"
                  item-text="nome"
                  item-value="sigla"
                  :label="$t('address.country')" />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="editedItem.cep"
                  :label="$t('address.postalCode')"
                  :loading="loadingCep || loadingGeocodeReverso"
                  @blur="consultaCEP" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" md="2">
                <v-text-field v-model="editedItem.estado" :loading="loadingCep || loadingGeocodeReverso" :label="$t('address.state')" />
              </v-col>
              <v-col cols="12" sm="5" md="5">
                <v-text-field v-model="editedItem.cidade" :loading="loadingCep || loadingGeocodeReverso" :label="$t('address.city')" />
              </v-col>
              <v-col cols="12" sm="5" md="5">
                <v-text-field v-model="editedItem.bairro" :loading="loadingCep || loadingGeocodeReverso" :label="$t('address.district')" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="9" md="9">
                <v-text-field v-model="editedItem.endereco" :loading="loadingCep || loadingGeocodeReverso" :label="$t('address.street')" />
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="editedItem.numero" :label="$t('address.number')" />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.lat" :label="$t('person.latitude')"
                  :loading="loadingGeocodeReverso" @blur="geocodeReversoPorCoordenada"
                  :hint="$t('externalAddress.form.coordinatesHint')" persistent-hint />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="editedItem.lng" :label="$t('person.longitude')"
                  :loading="loadingGeocodeReverso" @blur="geocodeReversoPorCoordenada" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :disabled="salvando" @click="fecharDialog">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="primary" class="white--text" :loading="salvando" @click="salvarEndereco">
            {{ $t('button.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container class="toolbar__container" style="margin-bottom: 0;">
      <v-row align="center">
        <v-col cols="12" sm="6" md="6">
          <v-select
            v-model="filtroAgenciaSelected"
            :items="agenciasFiltro"
            :item-text="agenciaLabel"
            item-value="id_agencia_emprego"
            :label="$t('externalAddress.filters.agency')"
            clearable
            @change="onAgenciaFiltroChange"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-select
            v-model="filtroTurnosSelected"
            :items="turnos"
            item-text="descricao_turno"
            item-value="id_turno"
            :label="$t('candidate.jobOffer.shift')"
            multiple
            chips
            deletable-chips
            small-chips
            clearable
          />
        </v-col>
      </v-row>
      <v-row v-if="filtroIds" dense>
        <v-col cols="12">
          <v-chip small close color="primary" outlined @click:close="limparFiltroIds">
            <v-icon x-small left>mdi-check-all</v-icon>
            {{ $t('relExternalAddressKpis.selection.fromReport', { count: totalFiltroIds }) }}
          </v-chip>
        </v-col>
      </v-row>
      <v-row v-if="filtroPoligono" dense>
        <v-col cols="12">
          <v-chip small close color="primary" outlined @click:close="$emit('limpar-poligono')">
            <v-icon x-small left>mdi-vector-polygon</v-icon>
            {{ $t('candidate.map.areaFilter') }}
          </v-chip>
        </v-col>
      </v-row>
      <KpisEnderecosOrigemPainel origem="E" :ativa="ativa" :id-agencia="filtroAgenciaSelected" :turnos="kpiTurnosVisiveis" />
    </v-container>

    <merus-data-table
      :headers="headers"
      :items="enderecos"
      :loading="loadingtable"
      :extra-headers="turnoColumnHeaders"
      :loading-text="validacaoLoadingText"
      :show-select="true"
      item-key="id_unico_endereco_externo"
      v-model="enderecosSelected"
      :server-items-length="totalEnderecos"
      :items-per-page="numberOfRows"
      :items-per-page-last-option="itemsPerPageLastOption"
      :server-sort-by="serverSortBy"
      :server-sort-desc="serverSortDesc"
      :default-multi-sort="defaultSort"
      fixed-header
      @update:options="onTableOptions"
      @update:filters="onFiltersUpdate"
      style="border-radius: 10px; margin-top: 0px; margin-bottom: 20px;">

      <template v-slot:toolbar>
        <CadastroToolbar
          :title="$t('externalAddress.title')"
          :token="token || ''"
          :items="enderecos"
          :load-items-for-export="loadItemsForExport"
          background-export
          list-endpoint="getallenderecosexternos"
          :export-filters="requestFilters"
          :export-sort-by="serverSortBy"
          :export-sort-desc="serverSortDesc"
          :export-total="totalEnderecos"
          :selected-ids="selectedEnderecosIds"
          id-field="id_unico_endereco_externo"
          :csv-title="$t('externalAddress.title')"
          :csv-headers="headersCsvExport"
          :pdf-title="$t('externalAddress.title')"
          :pdf-headers="headers"
          pdf-filename="enderecos-externos"
          hide-search>
          <template v-slot:add>
            <v-menu offset-y :close-on-content-click="false" min-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: onTooltip }">
                    <v-btn color="#4a4a4a" dark small class="mb-2 mr-2" fab v-bind="attrs" v-on="{ ...onTooltip, ...on }">
                      <v-icon>mdi-tune-variant</v-icon>
                    </v-btn>
                  </template>
                  <div>{{ $t('candidate.validationOptions.title') }}</div>
                </v-tooltip>
              </template>
              <v-card>
                <v-card-title class="text-subtitle-2 py-2">
                  {{ $t('candidate.validationOptions.title') }}
                </v-card-title>
                <v-divider />
                <v-card-text class="py-2">
                  <v-switch
                    v-model="validacaoCheckCapacity"
                    dense
                    hide-details
                    class="mt-0"
                    :label="$t('candidate.validationOptions.checkCapacity')" />
                  <v-switch
                    v-model="validacaoConsiderarReservas"
                    dense
                    hide-details
                    class="mt-0"
                    :label="$t('candidate.validationOptions.considerReservations')" />
                  <v-switch
                    v-model="validacaoCalcularCaminhada"
                    dense
                    hide-details
                    class="mt-0"
                    :label="$t('candidate.validationOptions.walkDistance')" />
                  <v-switch
                    v-model="validacaoConsiderarTempoPermanencia"
                    dense
                    hide-details
                    class="mt-0"
                    :label="$t('candidate.validationOptions.considerRideTime')" />
                  <v-text-field
                    v-model="validacaoTempoMaximoPermanencia"
                    :disabled="!validacaoConsiderarTempoPermanencia"
                    type="number"
                    min="1"
                    suffix="min"
                    dense
                    clearable
                    class="mt-3"
                    :label="$t('candidate.validationOptions.maxRideTime')"
                    :hint="$t('candidate.validationOptions.maxRideTimeHint')"
                    persistent-hint />
                </v-card-text>
              </v-card>
            </v-menu>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="#4a4a4a" dark small class="mb-2 mr-2" fab v-on="on"
                  @click="validaEnderecos([...enderecosSelected])">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </template>
              <div>{{ $t('externalAddress.validateSelected') }}</div>
            </v-tooltip>

            <!-- Ações da tela pai (cadastro em massa por CSV, em CRUDCandidatos). -->
            <slot name="toolbar-acoes" :carregando="loadingtable"></slot>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="#4a4a4a" dark small class="mb-2" fab v-on="on" @click="novoEndereco">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <div>{{ $t('externalAddress.newAddress') }}</div>
            </v-tooltip>
          </template>
        </CadastroToolbar>
      </template>

      <template v-slot:item.zonas_risco_label="{ item }">
        <ZonaRiscoChip :rotulo="item.zonas_risco_label" />
      </template>

      <template v-slot:item.id_endereco_externo="{ item }">
        {{ rotuloEndereco(item) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" color="blue" v-on="on" @click="validaEnderecos([item])">mdi-check</v-icon>
          </template>
          <div>{{ $t('externalAddress.validateRow') }}</div>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on" @click="editarEndereco(item)">mdi-pencil</v-icon>
          </template>
          <div>{{ $t('externalAddress.editAddress') }}</div>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" color="green darken-2" v-on="on"
              @click="$emit('progredir', item)">mdi-account-arrow-up</v-icon>
          </template>
          <div>{{ $t('externalAddress.promoteToCandidate') }}</div>
        </v-tooltip>
      </template>
    </merus-data-table>
  </div>
</template>

<script>
import axios from "axios";
import apiController from "@/utils/apiController";
import ZonaRiscoChip from "@/components/Areas/ZonaRiscoChip.vue";
import EventBus from "@/utils/eventBus";
import registrarChamadaApiExterna from "@/utils/registrarChamadaApiExterna";
import { reverseGeocodeBulk, fetchAllocationConfig } from "@/utils/allocationFenceCreation";
import { defaultCountry } from "@/constants";
import LoadingComponent from "../LoadingComponent.vue";
import KpisEnderecosOrigemPainel from "./KpisEnderecosOrigemPainel.vue";
import { COR_VALIDACAO, formatTempoValidacao } from "@/utils/kpisEnderecosExternos";
import MerusDataTable from "../Tables/MerusDataTable.vue";
import CadastroToolbar from "../Toolbars/CadastroToolbar.vue";
import serverTableMixin from "@/mixins/serverTableMixin";
import selecaoRevalidacaoMixin from "@/mixins/selecaoRevalidacaoMixin";
import validacaoSchedulerMixin from "@/mixins/validacaoSchedulerMixin";
import {
  buildRequestParams,
  computePageState,
  initSortFromDefault,
  fetchAllServerPagesForExport,
} from "@/utils/serverTablePagination";

/** Sem agência vinculada: valor sentinela do select (o backend traduz -1 para IS NULL). */
const AGENCIA_SEM_VINCULO = -1;

/** `enderecos` não tem complemento; lat/lng em branco são geocodificados no backend. */
const ENDERECO_VAZIO = {
  id_unico_endereco_externo: null,
  id_endereco_externo: null,
  id_agencia_emprego: null,
  pais: null,
  cep: null,
  estado: null,
  cidade: null,
  bairro: null,
  endereco: null,
  numero: null,
  lat: null,
  lng: null,
};

export default {
  name: "EnderecosExternosTab",
  components: {
    LoadingComponent,
    ZonaRiscoChip,
    MerusDataTable,
    CadastroToolbar,
    KpisEnderecosOrigemPainel,
  },
  mixins: [serverTableMixin, validacaoSchedulerMixin, selecaoRevalidacaoMixin],
  props: {
    /** Aba visível. A tela pai controla a ordem das abas; aqui só interessa estar ativa. */
    ativa: {
      type: Boolean,
      default: false,
    },
    token: {
      type: String,
      default: null,
    },
    /** Turnos já carregados pela tela pai (evita refazer o getallturnos). */
    turnos: {
      type: Array,
      default: () => [],
    },
    /** Agências já carregadas pela tela pai. */
    agencias: {
      type: Array,
      default: () => [],
    },
    /** Polígono desenhado no mapa ("lat,lng;lat,lng;..."): lista só os cadastros dentro dele e os marca. */
    filtroPoligono: {
      type: String,
      default: '',
    },
    /** Países já carregados pela tela pai (o endereço guarda a sigla). */
    paises: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    enderecos: [],
    enderecosSelected: [],
    loadingtable: false,
    totalEnderecos: 0,
    pageNumber: 1,
    numberOfRows: 10,
    itemsPerPageLastOption: 1000,
    lastItemsPerPageBeforeTodos: 10,
    serverSortBy: [],
    serverSortDesc: [],
    searchFilters: {},
    filtroAgenciaSelected: null,
    filtroTurnosSelected: [],
    // Capacidade, caminhada e tempo de permanência são opt-in, como no endpoint.
    validacaoCheckCapacity: false,
    validacaoConsiderarReservas: true,
    // Desligado, a validação fica na distância em linha reta (sem o planejador de rotas a pé).
    validacaoCalcularCaminhada: false,
    // Desligado, o tempo a bordo só é exibido: nenhuma linha é reprovada por ele.
    validacaoConsiderarTempoPermanencia: false,
    // Override manual do limite de permanência na linha; vazio herda linha/unidade/config.
    validacaoTempoMaximoPermanencia: null,
    carregado: false,
    dialog: false,
    validacaoDialog: false,
    validacaoResultados: [],
    editando: false,
    formValido: false,
    salvando: false,
    loadingCep: false,
    loadingGeocodeReverso: false,
    /** Coordenada com que o diálogo abriu: só busca endereço quando o usuário muda. */
    coordenadaOriginal: { lat: null, lng: null },
    editedItem: { ...ENDERECO_VAZIO },
  }),
  mounted() {
    // Depois do mounted do MerusDataTable: o update:options inicial dele já passou
    // e foi barrado por `carregado`, então não há requisição duplicada aqui.
    if (this.ativa) {
      this.ensureLoaded();
    }
  },
  watch: {
    ativa(value) {
      if (value) {
        this.ensureLoaded();
      }
    },
    // Recarregar a tabela (ex.: depois de revalidar) troca os objetos das linhas: a seleção
    // continua nas mesmas linhas, agora com os dados novos. Quem saiu da página fica como está.
    filtroPoligono(valor) {
      this.pageNumber = 1;
      if (valor) this.numberOfRows = this.itemsPerPageLastOption;
      Promise.resolve(this.serverTableLoad()).then(() => {
        if (!valor) return;
        // Soma ao que já estava marcado (inclusive em outras páginas).
        const marcados = new Set(this.enderecosSelected.map((l) => l.id_unico_endereco_externo));
        this.enderecosSelected = this.enderecosSelected.concat(this.enderecos.filter((l) => !marcados.has(l.id_unico_endereco_externo)));
        this.$emit('area-aplicada', { selecionados: this.enderecos.length, total: this.totalEnderecos });
      });
    },
    enderecos(linhas) {
      if (!this.enderecosSelected.length) return;
      const porChave = new Map((linhas || []).map((l) => [l.id_unico_endereco_externo, l]));
      this.enderecosSelected = this.enderecosSelected.map((s) => porChave.get(s.id_unico_endereco_externo) || s);
    },
    // O mapa vive na tela pai: ela plota as linhas marcadas nesta tabela.
    enderecosSelected: {
      handler(value) {
        this.$emit('update:selecao', Array.isArray(value) ? value : []);
      },
    },
  },
  computed: {
    /** Chips de KPI por turno: só os turnos escolhidos no filtro, na ordem da lista de turnos. */
    kpiTurnosVisiveis() {
      const selecionados = new Set((this.filtroTurnosSelected || []).map((id) => Number(id)));
      return (this.turnos || []).filter((t) => selecionados.has(Number(t.id_turno)));
    },
    /** As abas ficam montadas com v-show: só a aba visível exibe o loading, para não sobrepor as outras. */
    loading() {
      return this.ativa && (this.loadingtable ||
        this.loadingCep ||
        this.salvando ||
        this.loadingGeocodeReverso);
    },
    /**
     * Override manual do tempo máximo de permanência na linha, como o backend espera:
     * inteiro positivo de minutos, ou null para herdar linha / unidade / configurações.
     */
    tempoMaximoPermanenciaPayload() {
      const v = this.validacaoTempoMaximoPermanencia;
      if (v === null || v === undefined || v === '') return null;
      const n = Number(v);
      return Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
    },
    /** Mesmo formato do defaultSort das demais telas (value + options.value 1/-1). */
    defaultSort() {
      return [
        { value: 'id_endereco_externo', options: { text: this.$t('situations.increasing'), value: 1 } }];
    },
    headers() {
      // Sem cod-tabela: `sortable`/`filtrable` precisam vir explícitos
      // (o MerusDataTable não assume default quando os headers não vêm de tabelas_front).
      const col = (text, value) => ({ text, value, sortable: true, filtrable: true, show: true });
      return [
        col(this.$t('externalAddress.headers.externalId'), "id_endereco_externo"),
        col(this.$t('candidate.headers.main.agency'), "agencia_emprego"),
        col(this.$t('address.street'), "endereco"),
        col(this.$t('address.number'), "numero"),
        col(this.$t('address.district'), "bairro"),
        col(this.$t('address.city'), "cidade"),
        col(this.$t('address.postalCode'), "cep"),
        col(this.$t('address.state'), "estado"),
        col(this.$t('person.country'), "pais"),
        {
          text: this.$t('area.riskZone'),
          value: "zonas_risco_label",
          sortable: false,
          filtrable: false,
          show: true,
        },
        {
          text: this.$t('candidate.headers.main.lastValidation'),
          value: "dt_validacao_extenso",
          sortable: false,
          filtrable: false,
          show: true,
        },
        {
          text: this.$t('externalAddress.headers.validationTime'),
          value: "tempo_validacao",
          sortable: false,
          filtrable: false,
          show: true,
        },
        {
          text: this.$t('externalAddress.headers.walkCalculated'),
          value: "caminhada_calculada_label",
          sortable: false,
          filtrable: false,
          show: true,
        },
        {
          text: this.$t('candidate.headers.main.actions'),
          value: "actions",
          sortable: false,
          filtrable: false,
          show: true,
        },
      ];
    },
    headersCsvExport() {
      return this.headers
        .filter((h) => h && h.value && h.value !== "actions")
        .map((h) => ({ text: h.text != null ? h.text : String(h.value), value: h.value }));
    },
    agenciasFiltro() {
      return [
        { id_agencia_emprego: AGENCIA_SEM_VINCULO, cod_agencia: null, nome: this.$t('externalAddress.filters.noAgency') },
        ...(this.agencias || []),
      ];
    },
    validacaoTemErro() {
      return (this.validacaoResultados || []).some((r) => r.erro);
    },
    formTitle() {
      return this.editando
        ? this.$t('externalAddress.editAddress')
        : this.$t('externalAddress.newAddress');
    },
    selectedEnderecosIds() {
      return (this.enderecosSelected || [])
        .map((e) => e && e.id_unico_endereco_externo)
        .filter((id) => id != null);
    },
    /** Filtros de coluna + agência, no formato aceito por buildRequestParams. */
    requestFilters() {
      const filters = Object.assign({}, this.searchFilters);
      if (this.filtroAgenciaSelected != null && this.filtroAgenciaSelected !== '') {
        filters.id_agencia_emprego = this.filtroAgenciaSelected;
      }
      if (this.filtroIds) filters.ids = this.filtroIds;
      if (this.filtroPoligono) filters.poligono = this.filtroPoligono;
      return filters;
    },
    /** Colunas por turno, no mesmo formato que o CRUD de Candidatos usa. */
    turnoColumnHeaders() {
      const selected = Array.isArray(this.filtroTurnosSelected) ? this.filtroTurnosSelected : [];
      if (!selected.length) return [];
      const idSet = new Set(selected.map((id) => Number(id)));
      const headers = [];
      for (const t of this.turnos || []) {
        if (!idSet.has(Number(t.id_turno))) continue;
        const cod = t.cod_turno;
        const desc = t.descricao_turno;
        const base = { sortable: false, filtrable: false, show: true, to_show: 1, to_export: 1 };
        headers.push({ ...base, text: cod, value: `atende_${cod}` });
        if (desc) {
          headers.push({ ...base, text: `${cod} - ${this.$t('candidate.headers.main.distance')}`, value: `distancia_${desc}` });
          headers.push({ ...base, text: `${cod} - ${this.$t('candidate.rideTime.label')}`, value: `tempo_linha_${desc}` });
          headers.push({ ...base, text: `${cod} - ${this.$t('candidate.headers.main.bestLine')}`, value: `cod_linha_${desc}` });
          headers.push({ ...base, text: `${cod} - ${this.$t('candidate.headers.main.bestStop')}`, value: `cod_cerca_${desc}` });
        }
      }
      return headers;
    },
  },
  methods: {
    agenciaLabel(agencia) {
      if (!agencia) return '';
      const cod = agencia.cod_agencia != null ? String(agencia.cod_agencia).trim() : '';
      const nome = agencia.nome != null ? String(agencia.nome).trim() : '';
      if (cod && nome) return `${cod} - ${nome}`;
      return cod || nome;
    },
    /**
     * Carrega a página atual. Roda no mounted (quando a aba já abre ativa) e a cada
     * vez que a aba volta a ficar ativa, porque o conteúdo pode ter mudado enquanto
     * o usuário estava na outra aba. `carregado` só destrava os eventos que a tabela
     * emite ao montar — ver serverTableLoad().
     */
    ensureLoaded() {
      if (!this.carregado) {
        this.carregado = true;
        if (this.serverSortBy.length === 0 && this.defaultSort.length > 0) {
          const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
          this.serverSortBy = serverSortBy;
          this.serverSortDesc = serverSortDesc;
        }
      }
      const comSelecao = this.prepararSelecaoInicial();
      const carga = this.serverTableLoad();
      if (!comSelecao) return carga;
      return Promise.resolve(carga).then(() => {
        this.enderecosSelected = this.enderecos.slice();
      });
    },
    /** Duração da validação (ms) no mesmo formato do KPI de tempo médio. */
    formatTempoValidacao(ms) {
      return formatTempoValidacao(ms, this.$i18n && this.$i18n.locale);
    },
    novoEndereco() {
      this.editando = false;
      this.editedItem = { ...ENDERECO_VAZIO };
      this.coordenadaOriginal = { lat: null, lng: null };
      const padrao = (this.paises || []).find((pais) => pais.sigla === defaultCountry);
      if (padrao) this.editedItem.pais = padrao.sigla;
      this.dialog = true;
      this.$nextTick(() => {
        if (this.$refs.formEndereco) this.$refs.formEndereco.resetValidation();
      });
    },
    editarEndereco(item) {
      this.editando = true;
      this.editedItem = {
        ...ENDERECO_VAZIO,
        id_unico_endereco_externo: item.id_unico_endereco_externo,
        id_endereco_externo: item.id_endereco_externo,
        id_agencia_emprego: item.id_agencia_emprego,
        pais: item.pais,
        cep: item.cep,
        estado: item.estado,
        cidade: item.cidade,
        bairro: item.bairro,
        endereco: item.endereco,
        numero: item.numero,
        lat: item.lat,
        lng: item.lng,
      };
      this.coordenadaOriginal = { lat: item.lat, lng: item.lng };
      this.dialog = true;
      this.$nextTick(() => {
        if (this.$refs.formEndereco) this.$refs.formEndereco.resetValidation();
      });
    },
    fecharDialog() {
      this.dialog = false;
      this.editando = false;
      this.editedItem = { ...ENDERECO_VAZIO };
      this.coordenadaOriginal = { lat: null, lng: null };
    },
    /**
     * Coordenada informada à mão: busca o endereço daquele ponto (geocode reverso) e preenche
     * os campos de endereço, no provedor configurado em `api_geocodificacao_roteirizacao`.
     *
     * Só dispara quando a coordenada mudou em relação à que abriu o diálogo — abrir um
     * endereço já cadastrado e apenas passar pelo campo não pode reescrever o que está
     * gravado. É o caminho inverso do CEP: lá o endereço traz a coordenada, aqui a coordenada
     * traz o endereço.
     */
    async geocodeReversoPorCoordenada() {
      const lat = Number(this.editedItem.lat);
      const lng = Number(this.editedItem.lng);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
      const original = this.coordenadaOriginal || {};
      if (Number(original.lat) === lat && Number(original.lng) === lng) return;
      if (this.loadingGeocodeReverso) return;

      this.loadingGeocodeReverso = true;
      try {
        const config = await fetchAllocationConfig();
        const [resultado] = await reverseGeocodeBulk([{ lat, lng }], {
          provider: config.geocodeProvider,
          language: this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'pt-BR',
        });
        if (!resultado || resultado.error) {
          EventBus.$emit('show-alert', {
            tipo: 'warning',
            mensagem: this.$t('externalAddress.form.reverseGeocodeNotFound'),
          });
          return;
        }
        // Campo que o provedor não devolve fica como está: apagar o que o usuário digitou
        // seria pior que manter um dado que ele mesmo informou.
        const aplica = (campo, valor) => {
          if (valor != null && String(valor).trim() !== '') {
            this.editedItem[campo] = String(valor).trim();
          }
        };
        aplica('endereco', resultado.logradouro);
        aplica('numero', resultado.numero);
        aplica('bairro', resultado.bairro);
        aplica('cidade', resultado.cidade);
        aplica('estado', resultado.estado);
        aplica('cep', resultado.cep);
        // País só entra se a sigla existir na lista carregada (o select trabalha por sigla).
        const pais = (this.paises || []).find(
          (p) => p && resultado.pais && String(p.sigla).toUpperCase() === String(resultado.pais).toUpperCase()
        );
        if (pais) this.editedItem.pais = pais.sigla;
        // Coordenada consumida: sair do campo de novo sem mudar nada não repete a consulta.
        this.coordenadaOriginal = { lat, lng };
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.loadingGeocodeReverso = false;
      }
    },
    /** Preenche o endereço pelo CEP (ViaCEP), como no cadastro de candidatos. */
    consultaCEP() {
      if (this.editedItem.pais && String(this.editedItem.pais).toUpperCase() === 'MX') {
        return;
      }
      const cep = String(this.editedItem.cep || '').replace(/\D/g, '');
      if (cep.length !== 8) return;

      this.loadingCep = true;
      registrarChamadaApiExterna('VIACEP', 'CEP_LOOKUP', 1, this.token);
      axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        .then((response) => {
          if (!response.data.erro) {
            this.editedItem.endereco = response.data.logradouro;
            this.editedItem.cidade = response.data.localidade;
            this.editedItem.estado = response.data.uf;
            this.editedItem.bairro = response.data.bairro;
          }
        })
        .catch((e) => {
          EventBus.$emit('show-error', { error: e });
        })
        .finally(() => {
          this.loadingCep = false;
        });
    },
    /**
     * Cadastra (ou altera) o endereço externo. O backend grava `enderecos` +
     * `enderecos_externos` na mesma transação e geocodifica quando lat/lng ficam em branco.
     */
    async salvarEndereco() {
      if (this.$refs.formEndereco && !this.$refs.formEndereco.validate()) {
        return;
      }
      this.salvando = true;
      try {
        const response = await apiController.request(apiController.endpoints.upsertEnderecoexterno, {
          data: {
            id_unico_endereco_externo: this.editedItem.id_unico_endereco_externo,
            id_endereco_externo: this.editedItem.id_endereco_externo,
            id_agencia_emprego: this.editedItem.id_agencia_emprego,
            rua: this.editedItem.endereco,
            numero: this.editedItem.numero,
            bairro: this.editedItem.bairro,
            cidade: this.editedItem.cidade,
            cep: this.editedItem.cep,
            estado: this.editedItem.estado,
            pais: this.editedItem.pais,
            lat: this.editedItem.lat,
            lng: this.editedItem.lng,
            allowUpdate: this.editando,
          },
          silent: true,
        });
        this.fecharDialog();
        EventBus.$emit('show-alert', {
          tipo: 'success',
          mensagem: (response.data && response.data.mensagem) || this.$t('system.messages.saveSuccess'),
        });
        this.carregado = true;
        await this.serverTableLoad();
      } catch (e) {
        const mensagem = e && e.response && e.response.data && e.response.data.mensagem;
        if (mensagem) {
          EventBus.$emit('show-alert', { tipo: 'error', mensagem });
        } else {
          EventBus.$emit('show-error', { error: e });
        }
      } finally {
        this.salvando = false;
      }
    },
    onAgenciaFiltroChange() {
      this.pageNumber = 1;
      this.serverTableLoad();
    },
    serverTableLoad(options) {
      // Ignora os eventos que a tabela emite ao montar, enquanto a aba não foi aberta.
      if (!this.carregado) return Promise.resolve();
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.requestFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.totalEnderecos,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
      this.loadingtable = true;
      return (async () => {
        try {
          const response = await apiController.request(apiController.endpoints.getallEnderecosexternos, {
            data: params,
            config: { timeout: 120000 },
            silent: true,
          });
          const data = response.data;
          if (data && typeof data.total === 'number' && Array.isArray(data.items)) {
            this.enderecos = data.items;
            const updates = computePageState(
              data,
              { page, rowsPerPage, sortByArr, sortDescArr },
              state,
              this.itemsPerPageLastOption
            );
            this.totalEnderecos = updates.total;
            this.pageNumber = updates.pageNumber;
            this.numberOfRows = updates.numberOfRows;
            this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
            this.serverSortBy = updates.serverSortBy;
            this.serverSortDesc = updates.serverSortDesc;
          } else {
            this.enderecos = Array.isArray(data) ? data : [];
            this.totalEnderecos = this.enderecos.length;
          }
          if (data && data.erro) {
            EventBus.$emit('show-alert', { tipo: 'error', mensagem: data.mensagem });
          }
        } catch (e) {
          EventBus.$emit('show-error', { error: e });
          throw e;
        } finally {
          this.loadingtable = false;
        }
      })();
    },
    async loadItemsForExport(onProgress) {
      const selected = this.enderecosSelected;
      if (selected && selected.length > 0) {
        if (typeof onProgress === 'function') onProgress(100);
        return selected.slice();
      }
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await apiController.request(
            apiController.endpoints.getallEnderecosexternos,
            { data: params, config: { timeout: 120000 }, silent: true },
          );
          return response && response.data;
        },
        state: {
          total: this.totalEnderecos,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.requestFilters,
        },
        onProgress,
      });
    },
    /**
     * Valida os endereços no mesmo endpoint usado pela integração de agências
     * (POST /postvalidacaoenderecosexterno → validacandidatosbulk, modo enderecos_externos).
     */
    /**
     * Com menos de 30 itens a API valida na própria requisição e devolve o resultado; a partir
     * disso enfileira no worker do scheduler (202) e o resultado chega pelo acompanhamento.
     */
    validaEnderecos(lista, { permitirSemIdentificacao = false } = {}) {
      // Basta ter o id próprio da linha: o código externo é opcional no cadastro. No cadastro
      // em massa nem isso: a linha nova ganha o id próprio ao ser inserida.
      const itens = Array.isArray(lista)
        ? lista.filter((e) => e != null && (
          permitirSemIdentificacao || e.id_unico_endereco_externo != null || e.id_endereco_externo != null
        ))
        : [];
      if (itens.length === 0) {
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('externalAddress.validateNoSelection'),
        });
        return;
      }
      this.loadingtable = true;
      const timeoutMs = Math.max(180000, 90000 * Math.ceil(itens.length / 4));
      return (async () => {
        try {
          const response = await apiController.request(
            apiController.endpoints.postvalidacaoenderecosexterno,
            {
              data: {
                enderecos: itens.map((e) => ({
                  idExternal: e.id_endereco_externo,
                  idUnico: e.id_unico_endereco_externo,
                  id_agencia_emprego: e.id_agencia_emprego != null ? e.id_agencia_emprego : null,
                  rua: e.endereco,
                  numero: e.numero,
                  bairro: e.bairro,
                  cidade: e.cidade,
                  cep: e.cep,
                  estado: e.estado,
                  pais: e.pais,
                  lat: e.lat,
                  lng: e.lng,
                  checkCapacity: this.validacaoCheckCapacity,
                  considerarReservas: this.validacaoConsiderarReservas,
                  tempoMaximoPermanenciaLinha: this.tempoMaximoPermanenciaPayload,
                  considerarTempoPermanencia: this.validacaoConsiderarTempoPermanencia,
                })),
                checkCapacity: this.validacaoCheckCapacity,
                considerarReservas: this.validacaoConsiderarReservas,
                tempoMaximoPermanenciaLinha: this.tempoMaximoPermanenciaPayload,
                considerarTempoPermanencia: this.validacaoConsiderarTempoPermanencia,
                // A API só calcula a distância a pé quando pedida (menu de opções de validação).
                calcularCaminhada: this.validacaoCalcularCaminhada,
                permitirSemIdentificacao,
              },
              config: { timeout: timeoutMs },
              silent: true,
            }
          );
          // A distância a pé e a reprovação por raio vêm prontas do backend
          // (validacandidatosbulk chama o VROOM); nada a recalcular aqui.
          // Acima do limite da rota o lote é enfileirado (202): o POST volta na hora e o
          // resultado chega pelo scheduler, então a conexão não fica presa até o timeout.
          const data = await this.consumirRespostaValidacaoBulk(response, itens.length);
          this.validacaoResultados = this.buildValidacaoResultados(itens, data);
          this.validacaoDialog = true;
          await this.serverTableLoad();
        } catch (e) {
          const msg =
            e && e.code === 'ECONNABORTED'
              ? this.$t('candidate.validationRequestTimeout')
              : (e && e.message) || String(e);
          EventBus.$emit('show-alert', { tipo: 'error', mensagem: msg });
        } finally {
          this.encerrarValidacaoScheduler();
          this.loadingtable = false;
        }
      })();
    },
    /**
     * Linhas do CSV de cadastro em massa (diálogo em CRUDCandidatos): o código externo é
     * opcional, como no cadastro unitário.
     */
    cadastraEnderecosEmMassa(itens) {
      return this.validaEnderecos(itens, { permitirSemIdentificacao: true });
    },
    /**
     * Consulta o processo no scheduler. Fica no componente, e não no mixin, porque o gerador
     * do permissions.manifest.json só varre arquivos .vue: uma chamada a apiController.endpoints
     * escondida num .js faria a permissão do endpoint sumir desta tela.
     */
    buscarProcessoScheduler(idProcesso) {
      return apiController.request(apiController.endpoints.schedulerGetProcessoschedulerbyid, {
        data: { id_processo: idProcesso },
        config: { timeout: 30000 },
        silent: true,
      });
    },
    /**
     * Manda a API gravar o resultado do processo (o worker Python só valida) e devolve os
     * results[] já no formato da resposta síncrona. Fica no componente, e não no mixin, porque
     * o gerador do permissions.manifest.json só varre arquivos .vue.
     */
    aplicarValidacaoScheduler(idProcesso) {
      return apiController.request(apiController.endpoints.aplicaValidacaobulk, {
        data: { id_processo: idProcesso },
        config: { timeout: 300000 },
        silent: true,
      });
    },
    /** Rótulo do código `valido` da validação (mesma escala do CRUD de Candidatos). */
    labelValido(valido) {
      const n = Number(valido);
      const t = (k) => this.$t('addressValidation.' + k);
      if (n === 1) return t('statusAttends');
      if (n === 2) return t('statusAttendsNoSeat');
      if (n === 3) return t('statusAttendsNewStop');
      if (n === 4) return t('statusOutsideUnit');
      if (Number.isFinite(n)) return t('statusDoesNotAttend');
      return t('statusNoShiftValidation');
    },
    /** Endereço fora do raio de todas as unidades: todo turno volta "fora da unidade" e ele é reprovado. */
    foraDaUnidade(cercas) {
      return cercas.length > 0 && cercas.every((f) => Number(f.valido) === 4);
    },
    /** Nenhum turno atendido (atende, sem vaga ou criação de ponto): o endereço foi reprovado. */
    enderecoRejeitado(cercas) {
      return !cercas.some((f) => [1, 2, 3].includes(Number(f.valido)));
    },
    corValido(valido) {
      const n = Number(valido);
      if (COR_VALIDACAO[n]) return COR_VALIDACAO[n];
      return Number.isFinite(n) ? COR_VALIDACAO.other : COR_VALIDACAO.none;
    },
    /**
     * Uma cerca retornada pela validação vira uma linha da tabela do diálogo.
     * `distance` já vem como distância a pé quando a API conseguiu traçar o percurso
     * (flag walkDistance); senão é a distância em linha reta.
     */
    mapCercaValidacao(f) {
      const dash = '-';
      const turnoRow = (this.turnos || []).find((t) => Number(t.id_turno) === Number(f.idShift));
      const linhaReta = f.distance != null && f.distance !== '' ? Math.round(Number(f.distance)) : null;
      const rideMinutes = f.rideTimeMinutes != null && f.rideTimeMinutes !== ''
        ? Math.round(Number(f.rideTimeMinutes))
        : null;
      return {
        turno:
          f.codShift
          || (turnoRow && turnoRow.cod_turno)
          || f.descriptionShift
          || (f.idShift != null ? String(f.idShift) : dash),
        descricaoTurno: (turnoRow && turnoRow.descricao_turno) || f.descriptionShift || null,
        linha: f.codLine || f.nameLine || dash,
        cerca: f.codFence || f.nameFence || dash,
        distancia: linhaReta != null ? `${linhaReta} m` : dash,
        // walkDistance = a API conseguiu traçar o percurso a pé (VROOM);
        // sem ele o valor exibido é a linha reta e a tabela marca com *.
        distanciaReal: !!f.walkDistance,
        vagas: f.availableSeats != null && f.availableSeats !== '' ? String(f.availableSeats) : dash,
        status: this.labelValido(f.valido),
        cor: this.corValido(f.valido),
        // Tempo a bordo (embarque → unidade). Estourar o limite é só aviso.
        tempoLinha: rideMinutes == null
          ? dash
          : this.$t(f.rideTimeEstimated ? 'candidate.rideTime.estimated' : 'candidate.rideTime.minutes', { minutes: rideMinutes }),
        tempoLinhaExcede: f.exceedsMaxRideTime === true,
        tempoLinhaTooltip: f.exceedsMaxRideTime === true
          ? this.$t('candidate.rideTime.exceeds', { minutes: rideMinutes, max: f.maxRideTimeMinutes })
          : '',
        precisaAjusteTurno: !!f.needsShiftAdjustment,
      };
    },
    /**
     * Como a linha aparece no diálogo de validação: o código externo quando existe, senão
     * o id próprio marcado com # — endereço cadastrado só para validar não tem código.
     */
    rotuloEndereco(item) {
      if (!item) return '';
      if (item.id_endereco_externo != null && String(item.id_endereco_externo).trim() !== '') {
        return String(item.id_endereco_externo);
      }
      return item.id_unico_endereco_externo != null ? '#' + item.id_unico_endereco_externo : '';
    },
    enderecoResumo(item) {
      return [
        [item.endereco, item.numero].filter(Boolean).join(', '),
        item.bairro,
        item.cidade,
        item.estado,
      ].filter((v) => v != null && String(v).trim() !== '').join(' - ');
    },
    upsertLabel(acao) {
      if (acao === 'inserted') return this.$t('externalAddress.validationResult.upsertInserted');
      if (acao === 'updated') return this.$t('externalAddress.validationResult.upsertUpdated');
      if (acao === 'skipped') return this.$t('externalAddress.validationResult.upsertSkipped');
      return null;
    },
    /** Monta as linhas do diálogo a partir da resposta de /postvalidacaoenderecosexterno. */
    buildValidacaoResultados(itens, data) {
      const results = (data && data.results) || [];
      if (results.length === 0) {
        return [{
          idExternal: itens.length === 1 ? this.rotuloEndereco(itens[0]) : '',
          enderecoResumo: itens.length === 1 ? this.enderecoResumo(itens[0]) : '',
          erro: !!(data && data.erro),
          upsertLabel: null,
          tempoValidacao: null,
          caminhadaCalculada: null,
          mensagem: (data && data.mensagem) || this.$t('candidate.validationErrorGeneric'),
          cercas: [],
        }];
      }
      return results.map((r, i) => {
        // O resultado casa pelo id próprio da linha (o código externo pode nem existir);
        // o índice é o último recurso, para lotes vindos de integrações antigas.
        const item =
          itens.find(
            (e) => r.idUnico != null && Number(e.id_unico_endereco_externo) === Number(r.idUnico)
          )
          || itens.find(
            (e) => r.idExternal != null && String(e.id_endereco_externo) === String(r.idExternal)
          )
          || itens[i] || {};
        const validation = r.validation || {};
        // bestFences traz a melhor cerca por turno; validatedFences é o fallback
        // quando não houve escolha de melhor (ex.: fora do raio).
        const cercas = (validation.bestFences && validation.bestFences.length
          ? validation.bestFences
          : validation.validatedFences || []);
        const falhou = (r.erro && r.upsert_action !== 'skipped')
          || r.situacao_update_ok === false
          || this.foraDaUnidade(cercas);
        return {
          idExternal: r.idExternal != null
            ? r.idExternal
            : (r.idUnico != null ? '#' + r.idUnico : this.rotuloEndereco(item)),
          enderecoResumo: this.enderecoResumo(item),
          erro: !!falhou,
          rejeitado: this.enderecoRejeitado(cercas),
          upsertLabel: this.upsertLabel(r.upsert_action),
          tempoValidacao: this.formatTempoValidacao(r.tempo_validacao_ms),
          caminhadaCalculada: r.caminhada_calculada != null ? !!r.caminhada_calculada : null,
          mensagem:
            validation.message || r.erro || this.$t('candidate.validationErrorGeneric'),
          cercas: cercas.map((f) => this.mapCercaValidacao(f)),
        };
      });
    },
  },
};
</script>

<style scoped>
.validacao-status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.18);
  margin-right: 6px;
  vertical-align: middle;
}
</style>
